import { render, staticRenderFns } from "./TerminalsInput.vue?vue&type=template&id=056dbcd4&scoped=true&"
import script from "./TerminalsInput.vue?vue&type=script&lang=js&"
export * from "./TerminalsInput.vue?vue&type=script&lang=js&"
import style0 from "./TerminalsInput.vue?vue&type=style&index=0&id=056dbcd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056dbcd4",
  null
  
)

export default component.exports